import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltReactionsPanelItemWireframe from './VeltReactionsPanelItemWireframe/VeltReactionsPanelItemWireframe';
var VeltReactionsPanelItemsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reactions-panel-items-wireframe", __assign({}, transformedProps), children));
};
VeltReactionsPanelItemsWireframe.Item = VeltReactionsPanelItemWireframe;
export default VeltReactionsPanelItemsWireframe;
